// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3ixJi","buttons":"Footer_buttons__3xSUJ"};